export default class AddClassOnLoad {
    constructor(options) {
        this.attributeName = options.attributeName; // クラスを追加する属性名
        this.init(); // 初期設定としてイベントリスナーを設定
    }

    init() {
        window.addEventListener('load', this.addClass.bind(this)); // load イベントリスナーの追加
    }

    addClass() {
        const targetElements = document.querySelectorAll(`[${this.attributeName}]`); // 属性が設定されている要素を取得
        targetElements.forEach(elm => { // 各要素に対して処理
            const classToAdd = elm.getAttribute(this.attributeName); // 追加するクラス名を取得
            if (classToAdd && classToAdd.trim() !== '') {
                elm.classList.add(classToAdd); // クラスを追加
            }
        });
    }
}